export const formatJson = (json: string): string => {
    try {
        // eslint-disable-next-line no-magic-numbers
        return JSON.stringify(JSON.parse(json), null, 2);
    } catch (error) {
        // Return the original string if parsing fails
        return json;
    }
};
